











































































































































import mixins from 'vue-typed-mixins'
import DraftElement from '@/builder/sections/mixins/DraftElement'
import CCalendarEmployeePanel from '@/builder/sections/section/calendars/components/CCalendarEmployeePanel.vue'
import CCalendarCategoryPanel from '@/builder/sections/section/calendars/components/CCalendarCategoryPanel.vue'
import CCalendarServicePanel from '@/builder/sections/section/calendars/components/CCalendarServicePanel.vue'
import CCalendarLocationPanel from '@/builder/sections/section/calendars/components/CCalendarLocationPanel.vue'
import CCalendarSearchPreview from '@/builder/sections/section/calendars/components/CCalendarSearchPreview.vue'

export default mixins(DraftElement).extend({
  name: 'CCalendarPanels',
  components: {
    CCalendarEmployeePanel,
    CCalendarCategoryPanel,
    CCalendarServicePanel,
    CCalendarLocationPanel,
    CCalendarSearchPreview
  },
  props: {
    expandCollapseServicePanels: {
      type: Boolean,
      default: false
    },
    selectionOrder: {
      type: Array,
      default: () => ['location', 'service', 'employee']
    },
    separateOnlineLocations: {
      type: Boolean,
      default: false
    },
    serviceSearchEnabled: {
      type: Boolean,
      default: false
    },
    locationSearchEnabled: {
      type: Boolean,
      default: false
    },
    employeeSearchEnabled: {
      type: Boolean,
      default: false
    },
    selectLocationsTitle: {
      type: String,
      default: ''
    },
    selectServicesTitle: {
      type: String,
      default: ''
    },
    selectEmployeesTitle: {
      type: String,
      default: ''
    },
    classForViewRound: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: null
    },
    textColor: {
      type: String,
      default: null
    },
    isSettingRandomEmployeeSupported: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    order (): Array<string> {
      // The random-employee setting does NOT remove the step on the client -
      // it only pre-selects "any person" there; the step stays visible and
      // changeable. Only hidden employees remove it.
      const order = this.selectionOrder as Array<string>
      return this.areEmployeesHidden ? order.filter((stepKey: string) => stepKey !== 'employee') : order
    },
    onlineProviderTypes (): Array<number> {
      // Client-side LocationType ids: 3 Google Meet, 5 Zoom, 6 Microsoft Teams.
      return [3, 5, 6]
    },
    groupedOnlineSubtitle (): string {
      return this.onlineProviderTypes
        .map((providerType: number) => this.$trans('service_location_' + providerType))
        .join(', ')
    }
  }
})
